import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {papersActions} from "./papersSlice";
import {papersApi} from "~/api";

function* fetchPapersList(action) {
	try {
		const response = yield call(papersApi.gets, action.payload);
		yield put(papersActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch papers list', error);
		yield put(papersActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(papersActions.setFilter(action.payload));
}

export default function* papersSaga() {
	yield takeLatest(papersActions.fetchData.type, fetchPapersList);
	yield debounce(500, papersActions.setFilterWithDebounce.type, handleSearchDebounce)
}